<template>
    <multiselect
        :allow-empty="allowEmpty"
        :options="availableStatuses"
        :searchable="false"
        :show-labels="false"
        :value="selected"
        @input="handleInput"
        deselect-label=""
        placeholder="Semua"
        class="form-control"
        :multiple="true"
    >
        <template slot="singleLabel" slot-scope="{ option }">
            {{ option }}
        </template>
    </multiselect>
</template>

<script>
import { availableMemberStatuses } from "../helpers";
export default {
    data() {
        return {
            availableStatuses: availableMemberStatuses(),
            selected: null,
        };
    },
    methods: {
        handleInput(selected) {
            this.selected = selected;
            this.$emit("input", selected);
        },
    },
    props: {
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        value: {
            handler(newVal) {
                this.selected = newVal;
            },
            immediate: true,
        },
    },
};
</script>